module.exports = __webpack_public_path__ + "img/яблоки и желтый бокал 60х80.6efc1108.jpg";